export default {

    async ObtenerOtrosReportes(vm, datosbusqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Bitacora/ObtenerOtrosReportes`, datosbusqueda);
        return response.data
    },

    async ObtenerReportesAsistencias(vm, datosbusqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Bitacora/ObtenerReportesAsistencias`, datosbusqueda);
        return response.data;
    },

    async ObtenerReportesJuridicos(vm, datosbusqueda) {
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Bitacora/ObtenerReportesJuridicos`, datosbusqueda);
        return response.data;
    },
}